(function () {
  const DEBUG = true;
  const USE_READY_EVENT = true;
  const REBUY_DELAY_MS = 220;
  const DEBOUNCE_MS = 160;

  const PDP_MSG_SELECTOR   = '[data-promo-msg]';
  const REBUY_MSG_SELECTOR = '#rebuy-promo-msg';

  // === SOLO TAGS OFICIALES ====================================================
  // Igualdad exacta por token (normalizada a lower-case y espacios compactados)
  const TAGS = {
    necklaces: ['offert: necklaces'],
    bracelets: ['offert: capsules']
  };

  
  const TEXTS = {
  cart: {
    title: "Special Offers Just for You",
    unlocked: (label)=>`Nice! 20% off applies to all ${label}s in your cart.`,
    states: {
      '1': (label)=>`Add 2 more ${label}s to get 20% off.`,
      '2': (label)=>`Add 1 more ${label} to get 20% off.`
    }
  },
  pdp: {
    // PDP sin label: más sobrio y genérico para este producto
    '1':  ()=>`Add 2 more to get 20% off.`,
    '2':  ()=>`Add 1 more to get 20% off.`,
    '3+': ()=>`Nice! 20% off has been applied.`
  },
  groupLabel: {
    necklaces: 'Necklace',
    bracelets: 'Capsule'
  }
};


  const stateOf = (n)=> n>=3 ? '3+' : (n===2 ? '2' : (n===1 ? '1' : '0'));
  const norm = (t)=> String(t||'').toLowerCase().replace(/\s+/g,' ').trim();

  // En tu payload, product.tags suele venir como string "a, b, c"
  function extractRawTags(item){
    const s = item?.product?.tags || item?.product_tags || item?.tags;
    if (typeof s === 'string' && s.length) {
      return s.split(',').map(x=>x.trim());
    }
    const arr = item?.product?.tags || item?.tags || item?.product_tags_array;
    if (Array.isArray(arr)) return arr.map(String);
    return []; // no usamos fallbacks de tipo/handle porque pediste estrictamente los tags oficiales
  }

  function matchGroupsStrict(tags){
    const normalizedSet = new Set((tags||[]).map(norm));
    const out = new Set();
    for (const [group, requiredList] of Object.entries(TAGS)){
      // Si alguno de los tags oficiales del grupo está presente, cuenta
      if (requiredList.some(req => normalizedSet.has(norm(req)))) {
        out.add(group);
      }
    }
    return Array.from(out); // 0..2
  }

  function normalizeCartPayload(raw){
    let c = null;
    if (raw && Array.isArray(raw.items)) c = raw;
    else if (raw?.cart && Array.isArray(raw.cart.items)) c = raw.cart;
    else if (window.Rebuy?.Cart?.cart && Array.isArray(window.Rebuy.Cart.cart.items)) c = window.Rebuy.Cart.cart;
    if(!c) return null;
    return {...c, items: Array.isArray(c.items) ? c.items : []};
  }

  function getCountsFromCart(cart){
    let necklaces = 0, bracelets = 0;
    for (const li of (cart?.items || [])){
      const qty = Number(li.quantity || 0);
      if (!qty) continue;
      const groups = matchGroupsStrict(extractRawTags(li));
      if (groups.includes('necklaces')) necklaces += qty;
      if (groups.includes('bracelets')) bracelets += qty;
    }
    return { necklaces, bracelets };
  }

  function ensureRebuyContainer(){
    let el = document.querySelector(REBUY_MSG_SELECTOR);
    if (!el){
      const host = document.querySelector('#rebuy-cart, #rebuy-smart-cart, .rebuy-cart, .rebuy-smart-cart');
      if (host && host.parentNode){
        el = document.createElement('div');
        el.id = 'rebuy-promo-msg';
        el.style.display = 'none';
        el.setAttribute('aria-live','polite');
        host.parentNode.insertBefore(el, host);
      }
    }
    return el || document.querySelector(REBUY_MSG_SELECTOR);
  }

  function resolvePdpGroupsFromDOM(){
    const attr = document.documentElement?.dataset?.pdpTags || '';
    const raw = String(attr).split(',').map(s=>s.trim()).filter(Boolean);
    return raw.filter(v=>v==='necklaces' || v==='bracelets');
  }

  function renderPDP({ necklaces, bracelets }){
    const el = document.querySelector(PDP_MSG_SELECTOR);
    if (!el) return;

    const groups = resolvePdpGroupsFromDOM();
    if (!groups.length){ el.style.display='none'; el.textContent=''; return; }

    const counts = { necklaces, bracelets };
    let shown = false;

    for (const g of groups){
      const count = counts[g] || 0;
      const st = stateOf(count);
      if (st === '0') continue;
      const label = TEXTS.groupLabel[g];
      const msg = (st === '3+' ? TEXTS.pdp['3+'] : TEXTS.pdp[st])(label);
      if (DEBUG) console.log('[Promo][PDP]', { group:g, count, st, msg });
      if (msg){
        el.textContent = msg;
        el.style.display = '';
        shown = true;
        break;
      }
    }
    if (!shown){ el.style.display='none'; el.textContent=''; }
  }

  function renderCart({ necklaces, bracelets }){
  const el = ensureRebuyContainer();
  if (!el) return;

  const total = (necklaces||0) + (bracelets||0);
  if (total===0){ el.style.display='none'; el.innerHTML=''; return; }

  const blocks = [];
  const pushGroup = (count, key)=>{
    if (!count) return;
    const st = stateOf(count);
    if (st === '0') return;
    const label = TEXTS.groupLabel[key];
    if (st === '3+') blocks.push(TEXTS.cart.unlocked(label));
    else blocks.push(TEXTS.cart.states[st](label));
  };

  pushGroup(necklaces, 'necklaces');
  pushGroup(bracelets, 'bracelets');

  if (!blocks.length){ el.style.display='none'; el.innerHTML=''; return; }

  const titleHTML = TEXTS.cart && TEXTS.cart.title
    ? `<div class="promo-title">${TEXTS.cart.title}</div>`
    : '';

  // ⬇️ Usa <ul>/<li> en lugar de <div> para cada línea
  const listItemsHTML = blocks.map(b=>`<li class="promo-line">${b}</li>`).join('');
  el.innerHTML =
    `<div class="promo-box" role="region" aria-label="Promotions">
       ${titleHTML}
       <ul class="promo-list" role="list">
         ${listItemsHTML}
       </ul>
     </div>`;

  el.style.display = '';
  if (DEBUG) console.log('[Promo][CART]', { necklaces, bracelets, blocks });
}




  let rebuyTimer = null;
  let lastCartJSON = '';

  function scheduleRefresh(rawCartFromEvent){
    clearTimeout(rebuyTimer);
    rebuyTimer = setTimeout(()=>{
      setTimeout(()=>{
        try{
          const cartNorm =
            normalizeCartPayload(rawCartFromEvent) ||
            normalizeCartPayload(window.Rebuy?.Cart?.cart);
          if (!cartNorm) return;

          const payloadStr = JSON.stringify(cartNorm);
          if (payloadStr === lastCartJSON){
            if (DEBUG) console.log('[Promo] Cart unchanged. Skip render.');
            return;
          }
          lastCartJSON = payloadStr;

          const counts = getCountsFromCart(cartNorm);
          if (DEBUG) console.log('[Promo] Counts (strict tags):', counts);

          renderPDP(counts);
          renderCart(counts);
        } catch(e){
          if (DEBUG) console.warn('[Promo tags strict] render error', e);
        }
      }, REBUY_DELAY_MS);
    }, DEBOUNCE_MS);
  }

  if (USE_READY_EVENT){
    document.addEventListener('rebuy:smartcart.ready', (ev)=>{
      if (DEBUG) console.log('[Promo] rebuy:smartcart.ready', ev?.detail);
      scheduleRefresh(ev?.detail?.cart);
    });
  }
  document.addEventListener('rebuy:cart.change', (ev)=>{
    if (DEBUG) console.log('[Promo] rebuy:cart.change', ev?.detail);
    scheduleRefresh(ev?.detail?.cart);
  });
})();
